(() => {
  const initReportTabs = () => {
    document.querySelectorAll("[data-report-tabs]").forEach((container) => {
      const typeTabs = container.querySelectorAll("[data-tab-type]");
      const panels = container.querySelectorAll("[data-tab-panel]");
      const yearsContainer = container.querySelector(".report-tabs-years-inner");
      const yearIndicator = container.querySelector(".report-year-indicator");
      const typeIndicator = container.querySelector(".report-type-indicator");
      const typeInner = container.querySelector(".report-tabs-type-inner");
      const monthsRow = container.querySelector(".report-tabs-months");
      const monthsContainer = container.querySelector(".report-tabs-months-inner");
      const monthIndicator = container.querySelector(".report-month-indicator");

      // Get month labels from data attribute
      const monthLabelsAttr = container.getAttribute("data-month-labels");
      const monthLabels = monthLabelsAttr ? JSON.parse(monthLabelsAttr) : [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];

      // Scroll a tab button to the center of its scrollable parent
      const scrollTabToCenter = (btn) => {
        if (!btn) return;
        const scrollParent = btn.closest('.report-tabs-type, .report-tabs-years, .report-tabs-months');
        if (!scrollParent) return;
        const parentRect = scrollParent.getBoundingClientRect();
        const btnRect = btn.getBoundingClientRect();
        const scrollLeft = scrollParent.scrollLeft + (btnRect.left - parentRect.left) - (parentRect.width / 2) + (btnRect.width / 2);
        scrollParent.scrollTo({ left: scrollLeft, behavior: 'smooth' });
      };

      if (!typeTabs.length) return;

      const updateTypeIndicator = (btn) => {
        if (!typeIndicator || !btn || !typeInner) return;
        const parentRect = typeInner.getBoundingClientRect();
        const btnRect = btn.getBoundingClientRect();
        typeIndicator.style.width = `${btnRect.width}px`;
        typeIndicator.style.height = `${btnRect.height}px`;
        typeIndicator.style.left = `${btnRect.left - parentRect.left}px`;
      };

      const updateYearIndicator = (btn) => {
        if (!yearIndicator || !btn) return;
        const parentRect = yearsContainer.getBoundingClientRect();
        const btnRect = btn.getBoundingClientRect();
        yearIndicator.style.width = `${btnRect.width}px`;
        yearIndicator.style.left = `${btnRect.left - parentRect.left + yearsContainer.scrollLeft}px`;
      };

      const updateMonthIndicator = (btn) => {
        if (!monthIndicator || !btn || !monthsContainer) return;
        const parentRect = monthsContainer.getBoundingClientRect();
        const btnRect = btn.getBoundingClientRect();
        monthIndicator.style.width = `${btnRect.width}px`;
        monthIndicator.style.left = `${btnRect.left - parentRect.left + monthsContainer.scrollLeft}px`;
      };

      const buildMonthTabs = (yearGroup, initialMonth) => {
        if (!monthsContainer || !monthsRow) return;
        monthsContainer.innerHTML = "";

        const hasMonths = yearGroup.getAttribute("data-has-months") === "true";
        if (!hasMonths) {
          monthsRow.classList.add("hidden");
          return;
        }

        monthsRow.classList.remove("hidden");

        const monthsData = JSON.parse(yearGroup.getAttribute("data-months") || "[]");
        const monthGroups = yearGroup.querySelectorAll("[data-month-group]");

        // Determine which month index to activate
        const activeMonthIndex = initialMonth ? monthsData.indexOf(Number(initialMonth)) : -1;
        const defaultIndex = activeMonthIndex >= 0 ? activeMonthIndex : 0;

        monthsData.forEach((monthNum, i) => {
          const monthLabel = monthLabels[monthNum - 1] || `Month ${monthNum}`;
          const btn = document.createElement("button");
          btn.type = "button";
          btn.setAttribute("data-tab-month", monthNum);
          btn.setAttribute("aria-selected", i === defaultIndex ? "true" : "false");
          btn.className = "report-tab-month whitespace-nowrap py-m text-subheading-lg font-normal transition-colors " +
            (i === defaultIndex
              ? "is-active text-[#950a0a]"
              : "text-neutral-weaker hover:text-neutral-weak");
          btn.textContent = monthLabel;
          monthsContainer.appendChild(btn);
        });

        requestAnimationFrame(() => {
          const activeBtn = monthsContainer.querySelector(".is-active");
          updateMonthIndicator(activeBtn);
          if (initialMonth) scrollTabToCenter(activeBtn);
        });

        monthGroups.forEach((group, i) => {
          const monthNum = String(monthsData[i]);
          const targetMonth = initialMonth ? String(initialMonth) : String(monthsData[0]);
          group.classList.toggle("hidden", monthNum !== targetMonth);
        });

        monthsContainer.querySelectorAll("[data-tab-month]").forEach((monthBtn) => {
          monthBtn.addEventListener("click", () => {
            monthsContainer.querySelectorAll("[data-tab-month]").forEach((t) => {
              t.classList.remove("is-active", "text-[#950a0a]");
              t.classList.add("text-neutral-weaker");
              t.setAttribute("aria-selected", "false");
            });
            monthBtn.classList.remove("text-neutral-weaker");
            monthBtn.classList.add("is-active", "text-[#950a0a]");
            monthBtn.setAttribute("aria-selected", "true");

            updateMonthIndicator(monthBtn);
            scrollTabToCenter(monthBtn);

            const selectedMonth = monthBtn.getAttribute("data-tab-month");
            monthGroups.forEach((group) => {
              group.classList.toggle("hidden", group.getAttribute("data-month-group") !== selectedMonth);
            });
          });
        });
      };

      const buildYearTabs = (panelIndex, initialYear, initialMonth) => {
        if (!yearsContainer) return;
        yearsContainer.innerHTML = "";

        const panel = container.querySelector(`[data-tab-panel="${panelIndex}"]`);
        if (!panel) return;

        const yearGroups = panel.querySelectorAll("[data-year-group]");

        // Determine which year to activate
        let defaultYearIndex = 0;
        if (initialYear) {
          yearGroups.forEach((group, i) => {
            if (group.getAttribute("data-year-group") === initialYear) defaultYearIndex = i;
          });
        }

        yearGroups.forEach((group, i) => {
          const year = group.getAttribute("data-year-group");
          const btn = document.createElement("button");
          btn.type = "button";
          btn.setAttribute("data-tab-year", year);
          btn.setAttribute("aria-selected", i === defaultYearIndex ? "true" : "false");
          btn.className = "report-tab-year whitespace-nowrap py-m text-subheading-lg font-normal transition-colors " +
            (i === defaultYearIndex
              ? "is-active text-[#950a0a]"
              : "text-neutral-weaker hover:text-neutral-weak");
          btn.textContent = year;
          yearsContainer.appendChild(btn);
        });

        requestAnimationFrame(() => {
          const activeBtn = yearsContainer.querySelector(".is-active");
          updateYearIndicator(activeBtn);
          if (initialYear) scrollTabToCenter(activeBtn);
        });

        yearGroups.forEach((group, i) => {
          group.classList.toggle("hidden", i !== defaultYearIndex);
        });

        // Build month tabs for active year
        const activeYearGroup = yearGroups[defaultYearIndex];
        if (activeYearGroup) {
          buildMonthTabs(activeYearGroup, initialMonth);
        } else if (monthsRow) {
          monthsRow.classList.add("hidden");
        }

        yearsContainer.querySelectorAll("[data-tab-year]").forEach((yearBtn) => {
          yearBtn.addEventListener("click", () => {
            yearsContainer.querySelectorAll("[data-tab-year]").forEach((t) => {
              t.classList.remove("is-active", "text-[#950a0a]");
              t.classList.add("text-neutral-weaker");
              t.setAttribute("aria-selected", "false");
            });
            yearBtn.classList.remove("text-neutral-weaker");
            yearBtn.classList.add("is-active", "text-[#950a0a]");
            yearBtn.setAttribute("aria-selected", "true");

            updateYearIndicator(yearBtn);
            scrollTabToCenter(yearBtn);

            const selectedYear = yearBtn.getAttribute("data-tab-year");
            yearGroups.forEach((group) => {
              const isSelected = group.getAttribute("data-year-group") === selectedYear;
              group.classList.toggle("hidden", !isSelected);
              if (isSelected) {
                buildMonthTabs(group);
              }
            });
          });
        });
      };

      typeTabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          typeTabs.forEach((t) => {
            t.classList.remove("is-active", "text-inverse-strong");
            t.classList.add("text-neutral-weaker", "hover:text-neutral-weak");
            t.setAttribute("aria-selected", "false");
          });
          tab.classList.remove("text-neutral-weaker", "hover:text-neutral-weak");
          tab.classList.add("is-active", "text-inverse-strong");
          tab.setAttribute("aria-selected", "true");

          updateTypeIndicator(tab);
          scrollTabToCenter(tab);

          const selectedPanel = tab.getAttribute("data-tab-type");
          panels.forEach((panel) => {
            panel.classList.toggle("hidden", panel.getAttribute("data-tab-panel") !== selectedPanel);
          });

          buildYearTabs(selectedPanel);
        });
      });

      // Parse hash: #slug or #slug/year or #slug/year/month
      const parseHash = () => {
        const hash = window.location.hash.replace(/^#/, "");
        if (!hash) return null;
        const parts = hash.split("/");
        return {
          slug: parts[0] || null,
          year: parts[1] || null,
          month: parts[2] || null,
        };
      };

      // Find tab by slug
      const findTabBySlug = (slug) => {
        if (!slug) return null;
        for (const tab of typeTabs) {
          if (tab.getAttribute("data-tab-slug") === slug) return tab;
        }
        return null;
      };

      // Activate a specific type tab programmatically
      const activateTypeTab = (tab) => {
        typeTabs.forEach((t) => {
          t.classList.remove("is-active", "text-inverse-strong");
          t.classList.add("text-neutral-weaker", "hover:text-neutral-weak");
          t.setAttribute("aria-selected", "false");
        });
        tab.classList.remove("text-neutral-weaker", "hover:text-neutral-weak");
        tab.classList.add("is-active", "text-inverse-strong");
        tab.setAttribute("aria-selected", "true");

        updateTypeIndicator(tab);

        const selectedPanel = tab.getAttribute("data-tab-type");
        panels.forEach((panel) => {
          panel.classList.toggle("hidden", panel.getAttribute("data-tab-panel") !== selectedPanel);
        });

        return selectedPanel;
      };

      // Activate a specific year tab programmatically
      const activateYearTab = (year) => {
        const yearBtn = yearsContainer.querySelector(`[data-tab-year="${year}"]`);
        if (!yearBtn) return false;

        yearsContainer.querySelectorAll("[data-tab-year]").forEach((t) => {
          t.classList.remove("is-active", "text-[#950a0a]");
          t.classList.add("text-neutral-weaker");
          t.setAttribute("aria-selected", "false");
        });
        yearBtn.classList.remove("text-neutral-weaker");
        yearBtn.classList.add("is-active", "text-[#950a0a]");
        yearBtn.setAttribute("aria-selected", "true");

        updateYearIndicator(yearBtn);

        const panel = container.querySelector(`[data-tab-panel]:not(.hidden)`);
        if (panel) {
          const yearGroups = panel.querySelectorAll("[data-year-group]");
          yearGroups.forEach((group) => {
            const isSelected = group.getAttribute("data-year-group") === year;
            group.classList.toggle("hidden", !isSelected);
            if (isSelected) {
              buildMonthTabs(group);
            }
          });
        }
        return true;
      };

      // Activate a specific month tab programmatically
      const activateMonthTab = (month) => {
        if (!monthsContainer) return false;
        const monthBtn = monthsContainer.querySelector(`[data-tab-month="${month}"]`);
        if (!monthBtn) return false;

        monthsContainer.querySelectorAll("[data-tab-month]").forEach((t) => {
          t.classList.remove("is-active", "text-[#950a0a]");
          t.classList.add("text-neutral-weaker");
          t.setAttribute("aria-selected", "false");
        });
        monthBtn.classList.remove("text-neutral-weaker");
        monthBtn.classList.add("is-active", "text-[#950a0a]");
        monthBtn.setAttribute("aria-selected", "true");

        updateMonthIndicator(monthBtn);

        const visibleYearGroup = container.querySelector("[data-year-group]:not(.hidden)");
        if (visibleYearGroup) {
          visibleYearGroup.querySelectorAll("[data-month-group]").forEach((group) => {
            group.classList.toggle("hidden", group.getAttribute("data-month-group") !== month);
          });
        }
        return true;
      };

      // Initialize: check hash or default to first tab
      const hashParams = parseHash();
      const hashTab = hashParams ? findTabBySlug(hashParams.slug) : null;
      const initialTab = hashTab || typeTabs[0];

      if (initialTab) {
        if (typeIndicator) typeIndicator.style.transition = "none";
        const panelIndex = activateTypeTab(initialTab);
        buildYearTabs(panelIndex, hashParams ? hashParams.year : null, hashParams ? hashParams.month : null);

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            updateTypeIndicator(initialTab);
            if (typeIndicator) {
              void typeIndicator.offsetHeight;
              typeIndicator.style.transition = "";
            }

            // Scroll into view when hash is present
            if (hashParams && hashParams.slug) {
              container.scrollIntoView({ behavior: "smooth", block: "start" });
              scrollTabToCenter(initialTab);
            }
          });
        });
      }

      // Listen for hash changes (e.g. user clicks a link with #slug)
      window.addEventListener("hashchange", () => {
        const params = parseHash();
        if (!params || !params.slug) return;
        const tab = findTabBySlug(params.slug);
        if (!tab) return;

        const panelIndex = activateTypeTab(tab);
        buildYearTabs(panelIndex, params.year, params.month);

        requestAnimationFrame(() => {
          updateTypeIndicator(tab);
          container.scrollIntoView({ behavior: "smooth", block: "start" });
          scrollTabToCenter(tab);
        });
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initReportTabs);
  } else {
    initReportTabs();
  }
})();
